import React from 'react';
import { Link } from 'react-router-dom';

// On-voice 404 — replaces the catch-all redirect that silently
// teleported users to "/". Same warm composition as BootScreen so an
// unknown URL feels like the app, not a default browser response.
export default function NotFound() {
  return (
    <div
      style={{
        minHeight: '70vh',
        background: 'var(--bg)',
        display: 'grid',
        placeItems: 'center',
        padding: '2rem 1rem',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: '32rem' }}>
        <div className="av-eyebrow" style={{ color: 'var(--ink-3)', marginBottom: '0.75rem' }}>
          404 · Off the books
        </div>
        <h1
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: '2.5rem',
            lineHeight: 1.15,
            color: 'var(--ink)',
            fontWeight: 500,
            marginBottom: '0.75rem',
          }}
        >
          This page isn’t on the books.
        </h1>
        <p style={{ color: 'var(--ink-2)', fontSize: '0.9375rem', marginBottom: '1.75rem' }}>
          The link may be stale, or the page has moved. Head back to the start —
          everything else is one step from there.
        </p>
        <Link
          to="/"
          className="rounded-btn"
          style={{
            display: 'inline-block',
            padding: '0.625rem 1.125rem',
            border: '1px solid var(--line)',
            background: 'var(--bg-elev)',
            color: 'var(--ink)',
            fontSize: '0.875rem',
            fontWeight: 500,
            textDecoration: 'none',
          }}
        >
          Back to the start
        </Link>
      </div>
    </div>
  );
}
